import {
    STOCK_DOWNLOAD_SUMMARY_BEGIN,
    STOCK_DOWNLOAD_SUMMARY_SUCCESS,
    STOCK_DOWNLOAD_SUMMARY_FAILURE,
    STOCK_DOWNLOAD_SUMMARY_DISMISS_ERROR
  } from './constants'

  import { BFFAgent } from '../../../common/BFFAgent'
  import * as FileSaver from 'file-saver';
import { XML_TYPE } from 'Utilities';
  
  export  function downloadSummary(){
      return (dispatch, getState)=> { 
        const { stock: { stocks, translator, stockToProcess } } = getState()
        dispatch({
            type: STOCK_DOWNLOAD_SUMMARY_BEGIN,
        });
        BFFAgent.Stock.downloadSummary(stocks, translator, stockToProcess).then(
            (response) => {
                const file = new Blob(
                    [response],
                    {
                        type: XML_TYPE,
                    }
                )
                FileSaver.saveAs(file, 'ResumenCargaMasiva.xlsx')
                dispatch({
                    type: STOCK_DOWNLOAD_SUMMARY_SUCCESS,
                });
            },
            (err) => {
                dispatch({
                    type: STOCK_DOWNLOAD_SUMMARY_FAILURE,
                    data: { error: err },
                });
            },
        );
    };
  }

  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_DOWNLOAD_SUMMARY_BEGIN:
        return {
          ...state,
          confirmDownloadPending: true,
          confirmDownloadError: null,
          confirmDownloadSuccess: false,
        }
  
      case STOCK_DOWNLOAD_SUMMARY_SUCCESS:
        return {
          ...state,
          confirmDownloadPending: false,
          confirmDownloadSuccess: true,
        }
      case STOCK_DOWNLOAD_SUMMARY_FAILURE:
        return {
          ...state,
          confirmDownloadPending: false,
          confirmDownloadError: action.data.error,
        }
      case STOCK_DOWNLOAD_SUMMARY_DISMISS_ERROR:
        return {
          ...state,
          confirmDownloadError: null
        }
  
      default:
        return state
    }
  }
